import { render, staticRenderFns } from "./pageDiagnosis8.vue?vue&type=template&id=572b1308&scoped=true"
import script from "./pageDiagnosis8.vue?vue&type=script&lang=js"
export * from "./pageDiagnosis8.vue?vue&type=script&lang=js"
import style0 from "./pageDiagnosis8.vue?vue&type=style&index=0&id=572b1308&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572b1308",
  null
  
)

export default component.exports